import { render, staticRenderFns } from "./Messenger.vue?vue&type=template&id=6b60a616&"
import script from "./Messenger.vue?vue&type=script&lang=ts&"
export * from "./Messenger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports